"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.attainmentBreakdown = exports.attainmentGroups = exports.sankeyMobileNodes = exports.sankeyNodes = exports.sankeyLinks = exports.levels = void 0;
const lodash_1 = __importDefault(require("lodash"));
exports.levels = [{
  id: 'hsGrad',
  title: 'High school',
  label: 'Graduated?',
  nodes: ['hsGradYes', 'hsGradNo']
}, {
  id: 'colEnroll',
  title: 'College',
  label: 'Enrolled?',
  nodes: ['colEnroll2yrYes', 'colEnroll4yrYes', 'colEnrollNo']
}, {
  id: 'colGrad',
  label: 'Graduated?',
  nodes: ['colGrad2yrYes', 'colGrad2yrNo', 'colGrad4yrYes', 'colGrad4yrNo']
}];
exports.sankeyLinks = [{
  source: '',
  target: 'hsGradYes',
  metrics: [{
    name: 'All races',
    id: 'sotu583',
    unit: 'of all HS students'
  }, {
    name: 'White',
    id: 'sotu584',
    unit: 'of white HS students'
  }, {
    name: 'Black',
    id: 'sotu585',
    unit: 'of black HS students'
  }, {
    name: 'Hispanic',
    id: 'sotu586',
    unit: 'of hispanic HS students'
  }, {
    name: 'Asian',
    id: 'sotu587',
    unit: 'of asian HS students'
  }]
}, {
  source: '',
  target: 'hsGradNo',
  metrics: [{
    name: 'All races',
    id: 'sotu588',
    unit: 'of all HS students'
  }, {
    name: 'White',
    id: 'sotu589',
    unit: 'of white HS students'
  }, {
    name: 'Black',
    id: 'sotu590',
    unit: 'of black HS students'
  }, {
    name: 'Hispanic',
    id: 'sotu591',
    unit: 'of hispanic HS students'
  }, {
    name: 'Asian',
    id: 'sotu592',
    unit: 'of asian HS students'
  }]
}, {
  source: 'hsGradYes',
  target: 'colEnroll2yrYes',
  metrics: [{
    name: 'All races',
    id: 'sotu593',
    unit: 'of all HS grads'
  }, {
    name: 'White',
    id: 'sotu594',
    unit: 'of white HS grads'
  }, {
    name: 'Black',
    id: 'sotu595',
    unit: 'of black HS grads'
  }, {
    name: 'Hispanic',
    id: 'sotu596',
    unit: 'of hispanic HS grads'
  }, {
    name: 'Asian',
    id: 'sotu597',
    unit: 'of asian HS grads'
  }]
}, {
  source: 'hsGradYes',
  target: 'colEnroll4yrYes',
  metrics: [{
    name: 'All races',
    id: 'sotu598',
    unit: 'of all HS grads'
  }, {
    name: 'White',
    id: 'sotu599',
    unit: 'of white HS grads'
  }, {
    name: 'Black',
    id: 'sotu600',
    unit: 'of black HS grads'
  }, {
    name: 'Hispanic',
    id: 'sotu601',
    unit: 'of hispanic HS grads'
  }, {
    name: 'Asian',
    id: 'sotu602',
    unit: 'of asian HS grads'
  }]
}, {
  source: 'hsGradYes',
  target: 'colEnrollNo',
  metrics: [{
    name: 'All races',
    id: 'sotu603',
    unit: 'of all HS grads'
  }, {
    name: 'White',
    id: 'sotu604',
    unit: 'of white HS grads'
  }, {
    name: 'Black',
    id: 'sotu605',
    unit: 'of black HS grads'
  }, {
    name: 'Hispanic',
    id: 'sotu606',
    unit: 'of hispanic HS grads'
  }, {
    name: 'Asian',
    id: 'sotu607',
    unit: 'of asian HS grads'
  }]
}, {
  source: 'colEnroll2yrYes',
  target: 'colGrad2yrYes',
  metrics: [{
    name: 'All races',
    id: 'sotu608',
    unit: 'of all 2 year college students'
  }, {
    name: 'White',
    id: 'sotu609',
    unit: 'of white 2 year college students'
  }, {
    name: 'Black',
    id: 'sotu610',
    unit: 'of black 2 year college students'
  }, {
    name: 'Hispanic',
    id: 'sotu611',
    unit: 'of hispanic 2 year college students'
  }, {
    name: 'Asian',
    id: 'sotu612',
    unit: 'of asian 2 year college students'
  }]
}, {
  source: 'colEnroll2yrYes',
  target: 'colGrad2yrNo',
  color: 'target',
  metrics: [{
    name: 'All races',
    id: 'sotu658',
    unit: 'of all 2 year college students'
  }, {
    name: 'White',
    id: 'sotu659',
    unit: 'of white 2 year college students'
  }, {
    name: 'Black',
    id: 'sotu660',
    unit: 'of black 2 year college students'
  }, {
    name: 'Hispanic',
    id: 'sotu661',
    unit: 'of hispanic 2 year college students'
  }, {
    name: 'Asian',
    id: 'sotu662',
    unit: 'of asian 2 year college students'
  }]
}, {
  source: 'colEnroll4yrYes',
  target: 'colGrad4yrYes',
  metrics: [{
    name: 'All races',
    id: 'sotu613',
    unit: 'of all 4 year college students'
  }, {
    name: 'White',
    id: 'sotu614',
    unit: 'of white 4 year college students'
  }, {
    name: 'Black',
    id: 'sotu615',
    unit: 'of black 4 year college students'
  }, {
    name: 'Hispanic',
    id: 'sotu616',
    unit: 'of hispanic 4 year college students'
  }, {
    name: 'Asian',
    id: 'sotu617',
    unit: 'of asian 4 year college students'
  }]
}, {
  source: 'colEnroll4yrYes',
  target: 'colGrad4yrNo',
  color: 'target',
  metrics: [{
    name: 'All races',
    id: 'sotu663',
    unit: 'of all 4 year college students'
  }, {
    name: 'White',
    id: 'sotu664',
    unit: 'of white 4 year college students'
  }, {
    name: 'Black',
    id: 'sotu665',
    unit: 'of black 4 year college students'
  }, {
    name: 'Hispanic',
    id: 'sotu666',
    unit: 'of hispanic 4 year college students'
  }, {
    name: 'Asian',
    id: 'sotu667',
    unit: 'of asian 4 year college students'
  }]
}];
exports.sankeyNodes = [{
  id: 'hsGradYes',
  label: 'Yes',
  color: '#249EDC'
}, {
  id: 'hsGradNo',
  label: 'No',
  color: '#7EB6CE'
}, {
  id: 'colEnroll2yrYes',
  label: '2 yr',
  color: '#082D51'
}, {
  id: 'colEnroll4yrYes',
  label: '4 yr',
  color: '#082D51'
}, {
  id: 'colEnrollNo',
  label: 'No',
  color: '#249EDC'
}, {
  id: 'colGrad2yrYes',
  label: 'Yes',
  color: '#082D51'
}, {
  id: 'colGrad2yrNo',
  label: 'No',
  color: '#249EDC'
}, {
  id: 'colGrad4yrYes',
  label: 'Yes',
  color: '#082D51'
}, {
  id: 'colGrad4yrNo',
  label: 'No',
  color: '#249EDC'
}];
exports.sankeyMobileNodes = lodash_1.default.map(exports.sankeyNodes, node => ({
  ...node,
  label: node.id === 'colGrad2yrYes' ? 'Y' : node.label
}));
exports.attainmentGroups = [{
  key: 'college',
  label: 'College',
  color: '#082D51'
}, {
  key: 'hsgrad',
  label: 'HS Grad',
  color: '#249EDC'
}, {
  key: 'dnf',
  label: 'No HS',
  color: '#7EB6CE'
}];
exports.attainmentBreakdown = [{
  group: 'college',
  key: 'Advanced',
  label: 'Advanced degrees',
  metrics: [{
    name: 'All races',
    id: 'sotu633'
  }, {
    name: 'White',
    id: 'sotu634'
  }, {
    name: 'Black',
    id: 'sotu635'
  }, {
    name: 'Hispanic',
    id: 'sotu636'
  }, {
    name: 'Asian',
    id: 'sotu637'
  }]
}, {
  group: 'college',
  key: 'Bachelors',
  metrics: [{
    name: 'All races',
    id: 'sotu638'
  }, {
    name: 'White',
    id: 'sotu639'
  }, {
    name: 'Black',
    id: 'sotu640'
  }, {
    name: 'Hispanic',
    id: 'sotu641'
  }, {
    name: 'Asian',
    id: 'sotu642'
  }]
}, {
  group: 'college',
  key: 'Associates',
  metrics: [{
    name: 'All races',
    id: 'sotu643'
  }, {
    name: 'White',
    id: 'sotu644'
  }, {
    name: 'Black',
    id: 'sotu645'
  }, {
    name: 'Hispanic',
    id: 'sotu646'
  }, {
    name: 'Asian',
    id: 'sotu647'
  }]
}, {
  group: 'hsgrad',
  key: 'somecollege',
  label: 'Some college',
  metrics: [{
    name: 'All races',
    id: 'sotu648'
  }, {
    name: 'White',
    id: 'sotu649'
  }, {
    name: 'Black',
    id: 'sotu650'
  }, {
    name: 'Hispanic',
    id: 'sotu651'
  }, {
    name: 'Asian',
    id: 'sotu652'
  }]
}, {
  group: 'hsgrad',
  key: 'grad',
  label: 'HS grad',
  metrics: [{
    name: 'All races',
    id: 'sotu653'
  }, {
    name: 'White',
    id: 'sotu654'
  }, {
    name: 'Black',
    id: 'sotu655'
  }, {
    name: 'Hispanic',
    id: 'sotu656'
  }, {
    name: 'Asian',
    id: 'sotu657'
  }]
}, {
  group: 'dnf',
  key: 'dnfhs',
  label: 'No HS',
  metrics: [{
    name: 'All races',
    id: 'sotu628'
  }, {
    name: 'White',
    id: 'sotu629'
  }, {
    name: 'Black',
    id: 'sotu630'
  }, {
    name: 'Hispanic',
    id: 'sotu631'
  }, {
    name: 'Asian',
    id: 'sotu632'
  }]
}];